//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { BSidebar } from 'bootstrap-vue';
import { faTimes, faAngleLeft } from '@fortawesome/pro-regular-svg-icons';

export default {
  name: 'CustomSidebar',
  components: {
    BSidebar,
    NavLogo: () => import('@motionelements/core/src/components/nav/NavLogo.vue'),
  },
  props: {
    id: String,
    title: String,
    hideAllSidebar: String,
    backButton: Boolean,
    shown: Boolean,
    hidden: Boolean,
    width: {
      type: String,
      default: '100%',
    },
    right: {
      type: Boolean,
      default: false,
    },
    showLogo: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      faTimes,
      faAngleLeft,
    };
  },
  methods: {
    emitShown() {
      this.$emit('shown');
      // I try to do it with head() > bodyAttrs > class - but it dont work inside layout
      // disabled body scroll when sidebar is opened
      document.body.classList.add('modal-open');
    },
    emitHidden() {
      this.$emit('hidden');
      document.body.classList.remove('modal-open');
    },
  },
};
